// this mixin need inside every vue file which represents a view page

export default {
    data(){
        return{
            
        }
    }, 
    mounted(){
        if (this.$route.name != 'LogIn'){
            this.checkToken()
        }
        
    },
    watch:{
        $route(){
            this.checkToken()
        }
    },
    methods:{        
        checkToken(){
            // console.log('checktoken')
            //this function check the token is still valid
            let _this = this

            if (localStorage.getItem('ebus_token')) {
              _this.$store.state.token = localStorage.getItem('ebus_token');
            }

            _this.get('checktoken',
                {},
                function(resp){                
                    //console.log('checktoken', _this.$route.name, resp)                    
                    _this.$store.state.user = resp.data.user;                                                                                
                    // in the views the user ready function will run if the token is valid, so the user is logged in succesfull                
                    if (_this.userReady && _this.$store.state.user.status.toLowerCase() === 'active')
                    _this.userReady();
                  
                },function(){
                    //the token is invalid
                    //console.log('invalid token', resp)
                    localStorage.removeItem('ebus_token');
                    _this.$store.state.token = null
                    _this.$router.push({name: 'LogIn'})
                }
            )
        }
    
    }
}